import {TemplateList} from "~/libs/constants/TemplateList"
import type CncAdPosition from "~/libs/interfaces/CncAdPosition"
import {CncAdsPosition} from "~/libs/constants/CncAdsPosition"
import type CncAdPageProps from "~/libs/interfaces/CncAdPageProps"
import {CncAdsTemplate} from "~/libs/constants/CncAdsTemplate"
import {CncAdsForceArea} from "~/libs/constants/CncAdsForceArea"
import {CncAdsPage} from "~/libs/constants/CncAdsPage";
import {UniFeAdsPosition} from "~/libs/constants/UniFeAdsPosition";

export const CncAdsConfig: Record<TemplateList, CncAdPosition[]> = {
  [TemplateList.POGGERS]: [
    // LEADERBOARD_1
    {
      uniFePosition: UniFeAdsPosition.ABOVE_HEADER,
      cncPosition: CncAdsPosition.LEADERBOARD_1,
      page: [CncAdsPage.ALL],
      // disabledPage: [CncAdsPage.ARTICLE_GALLERY],
      showOnDesktop: true,
      showOnMobile: false
    },
    // HALFPAGE_1
    {
      uniFePosition: UniFeAdsPosition.COLUMN_STICKY,
      cncPosition: CncAdsPosition.HALFPAGE_1,
      page: [CncAdsPage.ALL],
      showOnDesktop: true,
      showOnMobile: false
    },
    // ArticleList Desktop - RECTANGLE_480_1
    {
      uniFePosition: UniFeAdsPosition.BELOW_ARTICLE,
      cncPosition: CncAdsPosition.RECTANGLE_480_1,
      page: [CncAdsPage.HOMEPAGE],
      showOnDesktop: true,
      showOnMobile: false,
      offset: 1,
    },
    {
      uniFePosition: UniFeAdsPosition.BELOW_ARTICLE,
      cncPosition: CncAdsPosition.RECTANGLE_480_1,
      page: [CncAdsPage.SECTION, CncAdsPage.SEARCH, CncAdsPage.AUTHOR],
      showOnDesktop: true,
      showOnMobile: false,
      offset: 2,
    },
    // ArticleList Mobile - MOBILE_RECTANGLE_2
    {
      uniFePosition: UniFeAdsPosition.ABOVE_ARTICLE,
      cncPosition: CncAdsPosition.MOBILE_RECTANGLE_2,
      page: [CncAdsPage.HOMEPAGE],
      showOnDesktop: false,
      showOnMobile: true,
      offset: 0,
    },
    {
      uniFePosition: UniFeAdsPosition.ABOVE_ARTICLE,
      cncPosition: CncAdsPosition.MOBILE_RECTANGLE_2,
      page: [CncAdsPage.SECTION, CncAdsPage.SEARCH, CncAdsPage.AUTHOR],
      showOnDesktop: false,
      showOnMobile: true,
      offset: 3,
    },
    // Article detail Desktop - RECTANGLE_480_1
    {
      uniFePosition: UniFeAdsPosition.BELOW_PEREX,
      cncPosition: CncAdsPosition.RECTANGLE_480_1,
      page: [CncAdsPage.ARTICLE_DETAIL],
      showOnDesktop: true,
      showOnMobile: false,
    },
    {
      uniFePosition: UniFeAdsPosition.BELOW_PEREX,
      cncPosition: CncAdsPosition.MOBILE_RECTANGLE_2,
      page: [CncAdsPage.ARTICLE_DETAIL],
      showOnDesktop: false,
      showOnMobile: true,
    },
    // Gallery Mobile - MOBILE_RECTANGLE_2
    {
      uniFePosition: UniFeAdsPosition.BELOW_IMAGE,
      cncPosition: CncAdsPosition.RECTANGLE_REPEATER_325,
      page: [CncAdsPage.ARTICLE_GALLERY],
      showOnDesktop: false,
      showOnMobile: true,
      offset: 2,
      repeatAfter: 3,
    },
  ],
  [TemplateList.MATERIDOUSKA]: [
    // LOCAL LEADERBOARD_1 - 12.05.2025
    // {
    //   uniFePosition: UniFeAdsPosition.ABOVE_HEADER,
    //   cncPosition: CncAdsPosition.LOCAL_LEADERBOARD_2,
    //   page: [CncAdsPage.ALL],
    //   showOnDesktop: true,
    //   showOnMobile: false,
    //   imageUrl: '/img/materidouska/ads/20250512/leaderboard.jpg',
    //   imageSet: '/img/materidouska/ads/20250512/leaderboard.jpg 1x, /img/materidouska/ads/20250512/leaderboard-retina.jpg 2x,',
    //   link: 'https://www.ikiosek.cz/materidouska',
    //   target: '_blank',
    // },
    // API LEADERBOARD_1
    {
      uniFePosition: UniFeAdsPosition.ABOVE_HEADER,
      cncPosition: CncAdsPosition.API_LEADERBOARD_1,
      page: [CncAdsPage.ALL],
      showOnDesktop: true,
      showOnMobile: false,
      link: 'https://www.ikiosek.cz/materidouska',
      target: '_blank',
      imageArticleId: '/api/articles/01JV2V3MNVSYR7DA4GVT4BXSNG', // originId - cehKxM8Tfs
      imageRetinaArticleId: '/api/articles/01JV2TVH5C0M5Y8DFM5WJABE9Z', // originId - cepWWnDyU2
    },
    // LOCAL HALFPAGE_1 - 12.05.2025
    // {
    //   uniFePosition: UniFeAdsPosition.COLUMN_STICKY,
    //   cncPosition: CncAdsPosition.LOCAL_HALFPAGE_2,
    //   page: [CncAdsPage.ALL],
    //   showOnDesktop: true,
    //   showOnMobile: false,
    //   imageUrl: '/img/materidouska/ads/20250512/halfpage.jpg',
    //   imageSet: '/img/materidouska/ads/20250512/halfpage.jpg 1x, /img/materidouska/ads/20250512/halfpage-retina.jpg 2x,',
    //   link: 'https://www.ikiosek.cz/materidouska',
    //   target: '_blank',
    // },
    // API HALFPAGE_1
    {
      uniFePosition: UniFeAdsPosition.COLUMN_STICKY,
      cncPosition: CncAdsPosition.API_HALFPAGE_1,
      page: [CncAdsPage.ALL],
      showOnDesktop: true,
      showOnMobile: false,
      link: 'https://www.ikiosek.cz/materidouska',
      target: '_blank',
      imageArticleId: '/api/articles/01JV2V7FXM1P2HW2MSCBGS235S', // originId - ceGLYLFp2e
      imageRetinaArticleId: '/api/articles/01JV2V99A8MV2JADYQXJ8XTT0B', // originId - ce3UM8eNCz
    },
  ]
}

export const CncAdsPageTypeConfig: Record<TemplateList, Partial<Record<CncAdsPage, CncAdPageProps>>> = {
  [TemplateList.POGGERS]: {
    [CncAdsPage.HOMEPAGE]: {
      template: CncAdsTemplate.CATEGORY,
      forceArea: CncAdsForceArea.HOMEPAGE,
    },
    [CncAdsPage.ARTICLE_DETAIL]: {
      template: CncAdsTemplate.ARTICLE,
      forceArea: CncAdsForceArea.OSTATNI,
    },
    [CncAdsPage.ARTICLE_GALLERY]: {
      template: CncAdsTemplate.GALLERY,
      forceArea: CncAdsForceArea.OSTATNI,
    }
  },
  [TemplateList.MATERIDOUSKA]: {},
}